// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DiffViewRenderer {
  font-family: var(--graphileon-font-family-code);
}
.DiffViewRenderer .diff-level {
  margin-left: 1.5em;
}
.DiffViewRenderer del.diff {
  text-decoration: none;
  color: var(--bs-danger);
  background: var(--bs-danger-bg-subtle);
}
.DiffViewRenderer ins.diff {
  background: var(--bs-success-bg-subtle);
  color: var(--bs-success);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/renderers/diff-view-renderer.scss"],"names":[],"mappings":"AAAA;EACC,+CAAA;AACD;AAAC;EACC,kBAAA;AAEF;AAAC;EACC,qBAAA;EACA,uBAAA;EACA,sCAAA;AAEF;AAAC;EACC,uCAAA;EACA,wBAAA;EACA,qBAAA;AAEF","sourcesContent":[".DiffViewRenderer {\n\tfont-family: var(--graphileon-font-family-code);\n\t.diff-level {\n\t\tmargin-left: 1.5em;\n\t}\n\tdel.diff {\n\t\ttext-decoration: none;\n\t\tcolor: var(--bs-danger);\n\t\tbackground: var(--bs-danger-bg-subtle);\n\t}\n\tins.diff {\n\t\tbackground: var(--bs-success-bg-subtle);\n\t\tcolor: var(--bs-success);\n\t\ttext-decoration: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
